import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import styles from "./styles";

const LoyaltyProgressIndicator = () => {
  return (
    <div className={styles.container}>
      <ProgressIndicator size="large" transparent />
    </div>
  );
};

export default LoyaltyProgressIndicator;
